<template>
	<div class="container">
		<!--页面开始-->
		<div class="main_box">
			<div class="msg_box">
				<van-form>
					<!--姓名-->
					<van-field
						v-model="form.username"
						name="姓名"
						placeholder="请输入姓名"
						required
						maxlength="30"
						ref="userName"
					>
						<span :decode="true" slot="label">姓&emsp;&emsp;&nbsp;名</span>
					</van-field>
					<!--姓名-->
					<!--证件类型-->
					<van-field
						readonly
						clickable
						name="picker"
						:value="form.cardType"
						label="证件类型"
						placeholder="请选择证件类型"
						required
						@click="showPicker = true"
					/>
					<van-popup v-model="showPicker" position="bottom">
						<van-picker
							show-toolbar
							:default-index="cardIndex"
							:columns="columns"
							@confirm="onConfirm"
							@cancel="showPicker = false"
						/>
					</van-popup>
					<!--证件类型-->
					<!--证件号码-->
					<van-field
						v-model="form.cardNumber"
						name="证件号码"
						label="证件号码"
						placeholder="请输入证件号码"
						required
						maxlength="18"
						ref="cardNumber"
					/>
					<!--证件号码-->
					<!--省市选择-->
					<van-field
						readonly
						clickable
						name="area"
						:value="form.city"
						label="现居住地"
						placeholder="请选择省/市/区（县）"
						required
						@click="showArea = true"
					/>
					<van-popup v-model="showArea" position="bottom">
						<van-area
							:value="form.citycode"
							:area-list="areaList"
							@confirm="cityConfirm"
							@cancel="showArea = false"
						/>
					</van-popup>
					<!--省市选择-->
					<!--街道选择-->
					<van-field
						v-if="isShowStreet"
						readonly
						clickable
						name="picker"
						:value="form.street_id"
						label="选择街道"
						placeholder="请选择街道"
						required
						@click="showStreet = true"
					/>
					<van-popup v-model="showStreet" position="bottom">
						<van-picker
							show-toolbar
							:default-index="streetIndex"
							value-key="title"
							:columns="streetColumns"
							@confirm="streetOnConfirm"
							@cancel="showStreet = false"
						/>
					</van-popup>
					<!--街道选择-->
					<!--详细地址-->
					<van-field
						v-model="form.address"
						name="详细地址"
						label="详细地址"
						placeholder="街道-小区-门牌号/乡村名-户号"
						required
						maxlength="100"
						ref="userAddress"
					/>
					<!--详细地址-->
					<!--手机号码-->
					<van-field
						v-if="userType == 2"
						v-model="form.phone"
						name="手机号码"
						label="手机号码"
						type="tel"
						placeholder="请输入手机号码"
						maxlength="11"
						ref="userPhone"
					/>
					<!--手机号码-->
				</van-form>
			</div>
			<div class="line_box">
				<van-divider />
			</div>
		</div>
		<!--页面开始-->
	    <!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { getInfo, saveMsg, cardType, streetList } from "@/api/public";
import { otherInfo, otherAdd, otherEdit } from "@/api/other/index";
import { shareUrl } from '@/utils/wxshare'
import { areaList } from '@vant/area-data';

export default {
	components:{
		//
	},
	props: [
		'type',
		'otherId',
	],
	data() {
		return {
			isLoading: true,
			columns: [],
			areaList: areaList, // 数据格式见 Area 组件文档
			showPicker: false,
			showArea: false,
			form: {  //用户信息
				username: '',
				cardType: '',
				cardNumber: '',
				city: '',
				citycode: '',
				address: '',
				phone: '',
				street_id: '',
			},
			cardTypeNumber: '',
			cardIndex: 0,
			cardType: [],  //证件类型
			userType: this.type,  //用户类型 1本人 2他人
			other_id: this.otherId,  //用户id
			docmHeight: document.documentElement.clientHeight,  //默认屏幕高度
			showHeight: document.documentElement.clientHeight,   //实时屏幕高度
			isShowStreet: false,  //所属街道
			showStreet: false,
			streetIndex: 0,
			streetColumns: [],  //街道数据
			streetNumber: '',
		}
	},
	created() {
		let that = this;
		if(that.userType == 1) {
			//获取本人信息
			getInfo().then(res1 => {
				//请求证件类型
				cardType().then(res => {
					that.cardType = res.data;
					for(var i in res.data) {
						that.columns.push(res.data[i].name);
						if(res.data[i].id == res1.token.card_type) {
							that.form.cardType = res.data[i].name;
						}
					}
					//请求所属街道
					streetList({
						county: res1.token.citycode,
					}).then(res2 => {
						that.streetColumns = res2.data;
						if(res2.data.length > 0) {
							that.isShowStreet = true;
							for(var i in res2.data) {
								if(res2.data[i].id == res1.token.street_id) {
									that.form.street_id = res2.data[i].title;
								}
							}
						}else {
							that.isShowStreet = false;
						}
						//个人信息回显
						that.form.username = res1.token.username;
						that.form.cardNumber = res1.token.card_number;
						that.form.city = res1.token.city;
						that.form.citycode = res1.token.citycode;
						that.form.address = res1.token.address;
						//that.cardIndex = res1.token.card_type - 1;
						//that.streetIndex = res1.token.street_id - 1;
						//console.log(that.streetIndex);
						//判断是否完善过个人信息
						if(res1.token.username && res1.token.card_type && res1.token.card_number && res1.token.city && res1.token.citycode && res1.token.address != "") {
							//已经完善个人信息
							that.$emit('initBtn2');
						}
						that.isLoading = false;
					});
				});
			});
		}else if(that.userType == 2) {
			//获取他人信息
			if(that.other_id) {
				//编辑
				otherInfo({id: that.other_id}).then(res1 => {
					//请求证件类型
					cardType().then(res => {
						that.cardType = res.data;
						for(var i in res.data) {
							that.columns.push(res.data[i].name);
							if(res.data[i].id == res1.data.card_type) {
								that.form.cardType = res.data[i].name;
							}
						}
						//请求所属街道
						streetList({
							county: res1.data.citycode,
						}).then(res2 => {
							that.streetColumns = res2.data;
							if(res2.data.length > 0) {
								that.isShowStreet = true;
								for(var i in res2.data) {
									if(res2.data[i].id == res1.data.street_id) {
										that.form.street_id = res2.data[i].title;
									}
								}
							}else {
								that.isShowStreet = false;
							}
							//个人信息回显
							that.form.username = res1.data.username;
							that.form.cardNumber = res1.data.card_number;
							that.form.city = res1.data.city;
							that.form.citycode = res1.data.citycode;
							that.form.address = res1.data.address;
							that.form.phone = res1.data.mobile;
							//that.cardIndex = res1.data.card_type - 1;
							//that.streetIndex = res1.data.street_id - 1;
							that.isLoading = false;
						});
					});
				});
			}else {
				//添加
				//请求证件类型
				cardType().then(res => {
					that.cardType = res.data;
					for(var i in res.data) {
						that.columns.push(res.data[i].name);
					}
					that.isLoading = false;
				});
			}
		}
	},
	mounted() {
		//微信分享
		let that = this;
		that.$nextTick(() => {
			shareUrl(that);
		});
		window.onresize = () => {
			return (() => {
				this.showHeight = document.documentElement.clientHeight;
			})()
		}
	},
	watch: {
		showHeight() {
			if(this.docmHeight > this.showHeight) {
				this.$emit('botHide');
			}else {
				this.$emit('botShow');
			}
		}
	},
	methods: {
		onConfirm(value) {
			this.form.cardType = value;
			this.showPicker = false;
		},
		//街道确定
		streetOnConfirm(value) {
			this.form.street_id = value.title;
			this.showStreet = false;
		},
		//城市确定
		cityConfirm(values) {
			let that = this;
			that.form.city = values
			.filter((item) => !!item)
			.map((item) => item.name)
			.join('/');
			let cityArr = '';
			if(values[values.length - 1]) {
				cityArr = values[values.length - 1];
			}else {
				cityArr = values[values.length - 2];
			}
			that.form.citycode = cityArr.code;
			//请求所属街道
			streetList({
				county: cityArr.code,
			}).then(res2 => {
				that.streetColumns = res2.data;
				if(res2.data.length > 0) {
					that.isShowStreet = true;
				}else {
					that.isShowStreet = false;
				}
				that.showArea = false;
			});
		},
		onSubmit() {
			let that = this;
			//非空校验
			if(that.form.username == '') {
				that.$toast('请输入姓名');
				that.$refs.userName.focus();
				return false;
			}
			if(that.form.cardType == '') {
				that.$toast('请选择证件类型');
				that.showPicker = true;
				return false;
			}
			if(that.form.cardNumber == '') {
				that.$toast('请输入证件号码');
				that.$refs.cardNumber.focus();
				return false;
			}
			if(that.form.city == '' || that.form.citycode == '') {
				that.$toast('请选择现居住地');
				that.showArea = true;
				return false;
			}
			if(that.streetColumns.length > 0) {
				for(var i in that.streetColumns) {
					if(that.form.street_id === that.streetColumns[i].title) {
						that.streetNumber = that.streetColumns[i].id;
					}
				}
				if(that.form.street_id == '') {
					that.$toast('请选择所属街道');
					return false;
				}
			}else {
				that.streetNumber = '';
			}
			if(that.form.address == '') {
				that.$toast('请输入详细地址');
				that.$refs.userAddress.focus();
				return false;
			}
			if(that.userType == 2 && that.form.phone != '') {
				if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.form.phone))){
					that.$toast("手机号码错误");
					that.$refs.userPhone.focus();
					return false;
				}
			}
			for(var i in that.cardType) {
				if(that.form.cardType === that.cardType[i].name) {
					that.cardTypeNumber = that.cardType[i].id;
				}
			}
			//证件类型判断
			//居民身份证
			if(that.cardTypeNumber == 1) {
				let pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
				if(!pattern.test(that.form.cardNumber)) {
					that.$toast('请输入有效的证件号码');
					that.$refs.cardNumber.focus();
					return false;
				}
			}
			//军官证
			/* if(that.cardTypeNumber == 2) {
				let pattern = /^[\u4E00-\u9FA5]{1,2}(字第)([0-9a-zA-Z]{4,8})(号?)$/;
				if(!pattern.test(that.form.cardNumber)) { that.$toast('请输入有效的证件号码'); return false; }
			} */
			//护照
			if(that.cardTypeNumber == 3) {
				/* let pattern = /^[a-zA-Z]{5,17}$ | [a-zA-Z0-9]{5,17}$/;
				if(!pattern.test(that.form.cardNumber)) { that.$toast('请输入有效的证件号码'); return false; } */
				//let str = that.form.cardNumber.slice(0, 1);  || str != 'E'
				if(that.form.cardNumber.length != 9) {
					that.$toast('请输入有效的证件号码');
					that.$refs.cardNumber.focus();
					return false;
				}
			}
			//外国人永久居留身份证
			if(that.cardTypeNumber == 4) {
				let pattern = /^[a-zA-Z]{3}\d{12}$/;
				if(!pattern.test(that.form.cardNumber)) {
					that.$toast('请输入有效的证件号码');
					that.$refs.cardNumber.focus();
					return false;
				}
			}
			//港澳居民来往内地通行证
			if(that.cardTypeNumber == 5) {
				let pattern = /^[HM]\d{10}$/;
				if(!pattern.test(that.form.cardNumber)) {
					that.$toast('请输入有效的证件号码');
					that.$refs.cardNumber.focus();
					return false;
				}
			}
			//港澳居民居住证
			if(that.cardTypeNumber == 6) {
				let pattern = /^8[12]0000(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dX]$/;
				if(!pattern.test(that.form.cardNumber)) {
					that.$toast('请输入有效的证件号码');
					that.$refs.cardNumber.focus();
					return false;
				}
			}
			//台湾居民来往大陆通行证
			if(that.cardTypeNumber == 7) {
				let pattern = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
				if(!pattern.test(that.form.cardNumber)) {
					that.$toast('请输入有效的证件号码');
					that.$refs.cardNumber.focus();
					return false;
				}
			}
			//台湾居民居住证
			if(that.cardTypeNumber == 8) {
				let pattern = /^830000(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dX]$/;
				if(!pattern.test(that.form.cardNumber)) {
					that.$toast('请输入有效的证件号码');
					that.$refs.cardNumber.focus();
					return false;
				}
			}
			//保存数据
			if(that.userType == 1) {
				//本人信息
				saveMsg(
					{
						username: that.form.username,
						type: that.cardTypeNumber,
						number: that.form.cardNumber,
						city: that.form.city,
						citycode: that.form.citycode,
						address: that.form.address,
						street_id: that.streetNumber,
					}
				).then(res => {
					that.$toast('保存成功');
					that.$emit('initBtn');
				});
			}else if(that.userType == 2) {
				//他人信息
				if(that.other_id) {
					//编辑
					otherEdit(
						{
							id: that.other_id,
							username: that.form.username,
							type: that.cardTypeNumber,
							number: that.form.cardNumber,
							city: that.form.city,
							citycode: that.form.citycode,
							address: that.form.address,
							mobile: that.form.phone,
							street_id: that.streetNumber,
						}
					).then(res => {
						that.$toast('保存成功');
						setTimeout(() => {
							that.$parent.goList();
						}, 500);
					});
				}else {
					//保存
					otherAdd(
						{
							username: that.form.username,
							type: that.cardTypeNumber,
							number: that.form.cardNumber,
							city: that.form.city,
							citycode: that.form.citycode,
							address: that.form.address,
							mobile: that.form.phone,
							street_id: that.streetNumber,
						}
					).then(res => {
						that.$toast('添加成功');
						setTimeout(() => {
							that.$parent.goList();
						}, 500);
					});
				}
			}
		},
	},
	beforeDestroy() {
		//
	}
}
</script>
</script>

<style scoped>
/*loading*/
.loading{width:100%;height:100%;min-height: 100vh;position:absolute;display:flex;justify-content:center;align-items:center;top:0;right:0;bottom:0;left:0;background:#ffffff;z-index:999;}

>>> .van-field__label{
	width: auto;
	min-width: 6.2em;
	max-width: 3rem;
}

.msg_box{
	display: flex;
	width: 100%;
	height: 100%;
	padding: 0.4rem 0.1rem 0rem 0.1rem;
	/* background-color: #F8F8F8; */
}
>>> .msg_box .van-form{
	width: 100%;
}
>>> .msg_box .van-cell{
	line-height: 0.9rem;
}
.van-button{
	height: 1.2rem;
}

.line_box{
	padding: 0 16px;
	position: relative;
	top: -0.4rem;
}

>>> .van-picker__confirm{
	color: #4f56fe;
}
</style>
